export const USER_LIST = "user_list";

export const SET_USER_DATA = "set_user_data";

export const LOGIN_SUCCESS = "LOGIN_SUCCESS";

export const LOGOUT = "LOGOUT";

export const PAGE_LOAD = "PAGE_LOAD"

export const CREDIT_UPDATE = "CREDIT_UPDATE";

export const SAVE_CONTENT = "SAVE_CONTENT";

export const ADD_REAL_TIME_NOTIFICATION = "ADD_REAL_TIME_NOTIFICATION";
export const SEED_NOTIFICATIONS = "SEED_NOTIFICATIONS";

export const MARK_NOTIFICATION_READ = "MARK_NOTIFICATION_READ";

export const MARK_ALL_NOTIFICATIONS_READ = "MARK_ALL_NOTIFICATIONS_READ";

export const CLEAR_NOTIFICATIONS = "CLEAR_NOTIFICATIONS";

/** Bumped when SSE signals a new email quote row should refresh listings */
export const BUMP_QUOTE_LIST_REFRESH = "BUMP_QUOTE_LIST_REFRESH";

// Tag constants
export const FETCH_TAGS = "FETCH_TAGS";
export const CREATE_TAG = "CREATE_TAG";
export const UPDATE_TAG = "UPDATE_TAG";
export const DELETE_TAG = "DELETE_TAG";
export const ASSIGN_TAG = "ASSIGN_TAG";
export const REMOVE_TAG = "REMOVE_TAG";
export const SET_TAGS = "SET_TAGS";
export const TAG_CREATED = "TAG_CREATED";
export const TAG_UPDATED = "TAG_UPDATED";
export const TAG_DELETED = "TAG_DELETED";
export const TAG_ASSIGNED = "TAG_ASSIGNED";
export const TAG_REMOVED = "TAG_REMOVED";